export async function updateCharacter({ userId, character, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/updateCharacter`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token || ""}`,
    },
    body: JSON.stringify({ userId, character }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || "Failed to update character");
  }
  return data;
}
